import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import { Store } from '@ngrx/store';
import {TransactionState} from '../../store/reducers/transaction.reducer';
import {
  TransactionDataTemplateDownloadAction,
  TransactionUploadSourceFileAction
} from '../../store/actions/transaction.actions';
import { CombineRoute } from '@shared/constants/RelativePath';
import {InvalidateSmartGridAction} from "@shared/store/actions/smart-grid.actions";
import {ISmartGridDataState} from "@shared/store/reducers/smart-grid.reducers";

@Component({
    standalone: false,
    selector: 'lib-app-transaction-import',
  templateUrl: './transaction-import.component.html',
  styleUrls: ['./transaction-import.component.scss']
})
export class TransactionImportComponent implements OnInit {
  FileToUpload: File;
  ImportFile: {name: string};

  // Horizontal Stepper
  Form: FormGroup;
  FormErrors: any;
  horizontalStepperStep1: any;
  private sourceType =  'Transaction';
  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private store: Store<TransactionState>,
              private smartGridStore: Store<ISmartGridDataState>) {
    this.ImportFile = {
      name : 'Transaction Data Template (.xlsx)'
    };
    // Horizontal Stepper form error
    this.FormErrors = {
      selectedFile: {},
      replaceExistingSelection : {}
    };
  }

  ngOnInit() {

    // Horizontal Stepper form steps
    this.Form = this.formBuilder.group({
      selectedFile: ['', Validators.required],
      replaceExistingSelection : [false]
    });

    this.Form.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
  }

  onFormValuesChanged() {
    for ( const field in this.FormErrors ) {
      if ( !this.FormErrors.hasOwnProperty(field) ) {
        continue;
      }

      // Clear previous errors
      this.FormErrors[field] = {};

      // Get the control
      const control = this.Form.get(field);

      if ( control && control.dirty && !control.valid ) {
        this.FormErrors[field] = control.errors;
      }
    }
  }

  cancel() {
    this.router.navigate(CombineRoute.TransactionRoute);
  }

  done() {
    this.store.dispatch(new TransactionUploadSourceFileAction(this.FileToUpload, this.Form.get('replaceExistingSelection').value, this.sourceType));
    //this.smartGridStore.dispatch(new InvalidateSmartGridAction(this.sourceType, true, true, true));
  }

  transactionDataTemplateDownload() {
    this.store.dispatch(new TransactionDataTemplateDownloadAction('Transaction Data Template.xlsx'));
  }

}
